import React from 'react';
import styled from 'styled-components';

import {Icon} from '../../../elements/Icon/Icon';

const Wrapper = styled.span`
    color: ${({color}) => color};
`;

export const FormIconLabel = ({name, children, color}) => (
    <Wrapper color={color}>
        <Icon name={name} color={color} />
        {children}
    </Wrapper>
);
